import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../services/firebase';
import { collection, where, orderBy, limit } from 'firebase/firestore';
import { useAuthBusiness } from './AuthBusinessContext';
import { subscriptionManager } from '../services/FirestoreSubscriptionManager';

const RealtimeDataContext = createContext();

export const useRealtimeData = () => {
  const context = useContext(RealtimeDataContext);
  if (!context) {
    throw new Error('useRealtimeData must be used within a RealtimeDataProvider');
  }
  return context;
};

export const RealtimeDataProvider = ({ children }) => {
  const { selectedBusiness } = useAuthBusiness();
  const [orders, setOrders] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [tables, setTables] = useState([]);

  useEffect(() => {
    if (!selectedBusiness?.id) {
      setOrders([]);
      setNotifications([]);
      setTables([]);
      return;
    }

    const bizId = selectedBusiness.id;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 1. Orders Subscription (Tek bağlantı)
    const ordersTopic = `orders_${bizId}`;
    const ordersConfig = {
      ref: collection(db, 'businesses', 'food_beverage', 'businesses', bizId, 'orders'),
      constraints: [
        where('status', 'in', ['pending', 'pending_approval', 'preparing', 'in_kitchen']),
        where('createdAt', '>=', today)
      ]
    };

    const unsubOrders = subscriptionManager.subscribe(ordersTopic, ordersConfig, (data) => {
      setOrders(data);
    });

    // 2. Notifications Subscription (Tek bağlantı, limit 25)
    const notifTopic = `notifications_${bizId}`;
    const notifConfig = {
      ref: collection(db, 'businesses', 'food_beverage', 'businesses', bizId, 'notifications'),
      constraints: [
        orderBy('createdAt', 'desc'),
        limit(25)
      ]
    };

    const unsubNotifs = subscriptionManager.subscribe(notifTopic, notifConfig, (data) => {
      setNotifications(data);
    });

    return () => {
      unsubOrders();
      unsubNotifs();
    };
  }, [selectedBusiness?.id]);

  const pendingOrders = orders.filter(o => ['pending', 'pending_approval'].includes(o.status));
  const pendingCount = pendingOrders.length;
  const unreadNotificationsCount = notifications.filter(n => !n.read).length;

  return (
    <RealtimeDataContext.Provider value={{
      orders,
      pendingOrders,
      pendingCount,
      notifications,
      unreadNotificationsCount,
      tables
    }}>
      {children}
    </RealtimeDataContext.Provider>
  );
};

export default RealtimeDataContext;
